import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useHotelMarkupsData = () => {
    const getHotelMarkupsData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}hotel/markups${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postHotelMarkupsData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}hotel/markups${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}hotel/markups${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putHotelMarkupsData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}hotel/markups${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchHotelMarkupsData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}hotel/markups${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteHotelMarkupsData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}hotel/markups${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getHotelMarkupsData,
        postHotelMarkupsData,
        putHotelMarkupsData,
        patchHotelMarkupsData,
        deleteHotelMarkupsData
    };

};